export interface PaginationInfo {
	total: number;
	previous: number | null;
	next: number | null;
	current: number;
	pages: number;
}
export const ROWS_PER_PAGE = [5, 10, 15, 25, 50, 100];
